import SubheaderComponent from './subheader'

export const Subheader =(props)=>{
  return(
    <SubheaderComponent {...props}/>
  )
}